import { MoneyConnectClientAPI } from "./axios-service-creator";

export const RegisterAPI = {
  getDefault: () =>
    MoneyConnectClientAPI.get("/customer/profile/register/default"),
  register: (payload) =>
    MoneyConnectClientAPI.post("/customer/profile/register", payload),
  updateProfile: (payload) =>
    MoneyConnectClientAPI.post("/customer/profile/data/update", payload),
};
